import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
} from '@mui/material';
import { useAddRelationship } from '../../hooks/useRelationship';

const RelationshipForm = ({ open, onClose, formData, onInputChange }) => {
    const addRelationship = useAddRelationship();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await addRelationship.mutateAsync(formData);
            onClose();
        } catch (error) {
            console.error('Error adding relationship:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle className="bg-blueColor text-white py-4">
                <i className="fas fa-plus text-xl mx-2"></i>
                <span className="text-xl font-semibold">Add New Relationship</span>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent className="mt-4">
                    <div className="grid grid-cols-1 gap-4 p-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Name
                            </label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={onInputChange}
                                type="text"
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Description
                            </label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={onInputChange}
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                                rows="4"
                            />
                        </div>
                    </div>
                    <div className="flex justify-end gap-4 mt-6 p-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blueColor text-white rounded"
                        >
                            Add
                        </button>
                    </div>
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default RelationshipForm; 